module.exports = __webpack_public_path__ + "img/40_69_007_060.c5e716b3.jpg";